import _objectWithoutProperties from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["label", "name"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TextBox from './TextBox';
import { IconButton } from '../buttons';
import { VisibilityIconOff, VisibilityIconOn } from '../icons';
import '../assets/inputFields.css';
const PasswordBox = _ref => {
  let {
      label,
      name
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const [showVisibilityOn, setShowVisibilityOn] = useState(false);
  const getToggleButton = () => /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => setShowVisibilityOn(!showVisibilityOn),
    icon: showVisibilityOn ? VisibilityIconOn : VisibilityIconOff
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextBox, _extends({}, rest, {
    type: showVisibilityOn ? 'text' : 'password',
    name: name,
    label: label,
    endAdornmentText: getToggleButton(),
    required: true
  })));
};
PasswordBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  email: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  elKey: PropTypes.any
};
export default PasswordBox;